import {Brand, RecipeCarouselV2Filter} from '@mfb/lego';
import {sortBy, uniqBy} from 'lodash';

import {GroupedPreferenceModel} from '../../../customGraphQlModels/GroupedPreferenceModel';

export const ALL_FILTER_ID = 'all';

// Diabetes shares the My Choice SKUs, so its carousel must be narrowed to the diabetes recipes (DIS-13087).
const DIETARY_PREFERENCES = ['MFBDiabetes'];

interface HasPreferenceCodes {
  preferenceCodes: Array<string>;
}

const flattenPreferences = (nodes: Array<GroupedPreferenceModel>): Array<GroupedPreferenceModel> =>
  nodes.flatMap(node =>
    node.childPreferences && node.childPreferences.length > 0 ? flattenPreferences(node.childPreferences) : [node]
  );

export const getRecipeCarouselV2Filters = (
  preferences: Array<GroupedPreferenceModel>,
  brand: Brand | undefined,
  recipes: Array<HasPreferenceCodes>
): Array<RecipeCarouselV2Filter> => {
  const codesInWeek = new Set(recipes.flatMap(r => r.preferenceCodes));

  const matching = uniqBy(
    sortBy(
      flattenPreferences(preferences).filter(
        p => p.brand === brand && p.preferenceName && codesInWeek.has(p.preferenceName)
      ),
      p => p.sortOrder ?? 0
    ),
    p => p.preferenceName
  );

  if (matching.length === 0) {
    return [];
  }

  return [
    {id: ALL_FILTER_ID, label: 'All'},
    ...matching.map(p => ({id: p.preferenceName ?? '', label: p.displayName ?? p.preferenceName ?? ''})),
  ];
};

export const filterRecipesByPreference = <T extends HasPreferenceCodes>(recipes: Array<T>, filterId: string): Array<T> =>
  filterId === ALL_FILTER_ID ? recipes : recipes.filter(r => r.preferenceCodes.includes(filterId));

export const getRecipeCarouselV2PreferenceCode = (preferenceName?: string): string | undefined =>
  preferenceName && DIETARY_PREFERENCES.includes(preferenceName) ? preferenceName : undefined;
